import { IntegrationType } from './IntegrationType';
export abstract class BaseIntegrationProps {

    protected root: HTMLElement;
    protected endpointUrl: URL;
    protected tenantId: string;
    protected pendoApiKey: string;
    protected userId: string;
    protected username: string;
    protected userType: string;
    protected abstract integrationType: IntegrationType;

    constructor(root: HTMLElement) {
        this.root = root;
        this.tenantId = this.getAttribute('REACT_APP_TENANT_ID', 'data-tenant-id');
        const endpoint = this.getAttribute('REACT_APP_ENDPOINT_URL', 'data-src-url');
        this.pendoApiKey = this.getAttribute('REACT_APP_PENDO_API_KEY', 'data-pendo-api-key');
        this.userId = this.getAttribute('REACT_APP_USER_ID', 'data-user-id');
        this.username = this.getAttribute('REACT_APP_USERNAME', 'data-username');
        this.userType = this.getAttribute('REACT_APP_USER_TYPE', 'data-user-type');
        try {
            this.endpointUrl = new URL(endpoint);
        } catch (error) {
            this.endpointUrl = new URL(window.location.href);
            this.endpointUrl.pathname = '';
        }
    }

    abstract getSessionHeaders(): { [key: string]: unknown }
    abstract getProductAdminType(): string;

    getMissingPropertyError(): Error | null {
        if (!this.tenantId) {
            return new Error('Current Tenant ID is null');
        }
        return null;
    }

    getEndpointUrl(): URL {
        return this.endpointUrl;
    }

    getIntegrationType(): IntegrationType {
        return this.integrationType;
    }

    getTenantId(): string {
        return this.tenantId;
    }

    getPendoAPIKey(): string {
        return this.pendoApiKey;
    }

    getUserId(): string {
        return this.userId;
    }

    getUsername(): string {
        return this.username;
    }

    getUserType(): string {
        return this.userType;
    }

    protected getAttribute(envKey: string, dataAttributeName: string): string {
        if (process.env[envKey]) {
            return process.env[envKey] as string;
        }
        return this.root.getAttribute(dataAttributeName) || '';
    }
}
